import { OrganizationAvatar, OrganizationAvatarProps } from "@facade/shared";

import { Typography } from "@facade/components/ui";
import { organizationsQueries } from "@facade/features/organization";
import { useSuspenseQuery } from "@tanstack/react-query";

export const OrganizationInfo = ({
  organizationId,
  ...rest
}: OrganizationAvatarProps & {
  organizationId: string;
}) => {
  const { data: organization } = useSuspenseQuery(
    organizationsQueries.publicDetail(organizationId),
  );

  return (
    <>
      <OrganizationAvatar
        imageAttachmentId={organization.imageId}
        organizationId={organizationId}
        size="lg"
        {...rest}
      />
      <div className="flex-1 overflow-hidden">
        <Typography className="leading-none whitespace-nowrap overflow-hidden text-ellipsis">
          {organization.name}
        </Typography>
        <Typography variant="text-muted">{"Organization"}</Typography>
      </div>
    </>
  );
};
